<template>
  <div id="page-body-wrap">
    <header-menu></header-menu>
    <div id="main" role="main">
      <div class="mod modDefaultSlider" id="index-slider">
        <div class="sequence" data-autostop="on" data-timeout="0"> <a class="sequence-prev"
            href="javascript:void(0);"><span></span></a> <a class="sequence-next"
            href="javascript:void(0);"><span></span></a>
          <ul class="sequence-pagination">
            <li class='current'></li>
            <li class=''></li>
            <li class=''></li>
            <li class=''></li>
            <li class=''></li>
            <li class=''></li>
            <!--  <li class=''></li>-->
          </ul>
          <ul class="sequence-canvas">
            <li class="frame static">
              <div class="bg" style="background-image: url('/skin/images/1.jpg');"></div>
            </li>
            <li class="frame static">
              <div class="bg" style="background-image: url('/skin/images/2.jpg');"></div>
            </li>
            <li class="frame static">
              <div class="bg" style="background-image: url('/skin/images/3.jpg');"></div>
            </li>
            <li class="frame static">
              <div class="bg" style="background-image: url('/skin/images/4.jpg');"></div>
            </li>
            <li class="frame static">
              <div class="bg" style="background-image: url('/skin/images/5.jpg');"></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="full section-padding" id="index-service">
        <div class="container">
          <div class="row">
            <div class="large-12 columns">
              <div class="mod modSectionHeader">
                <div class="special-title centered-text">
                  <h2>一站式服务</h2>
                </div>
              </div>
              <p class="desc-p">在服务方面力求尽善尽美。在绿化租摆等业务上，将本着认真负责的态度，由专业人员以熟练的园艺技能为客户提供优质的服务。</p>
            </div>
          </div>
          <div class="row">
            <div class="medium-6 columns iserv-img"> <img class="fadeinleft" src="/skin/images/company.jpg"> </div>
            <div class="medium-6 columns iserv-text">
              <div class="fadein mod modIconText appear"  v-for="(item) in articleList" :key="item.articleId" >
                <a :href="'articleDetail.html?id='+item.articleId">
                  <div class="icon-text-simple"> <i class="fa fa-pagelines"></i>
                    <h3>{{item.articleTitle}}</h3>
                    <p>{{item.articleAbstract}}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full parallax" id="index-parallax">
        <div class="container">
          <div class="row">
            <div class="large-12 columns">
              <div class="mod modSectionHeader">
                <div class="special-title centered-text">
                  <h2 class="color-white">绿植租赁流程</h2>
                </div>
              </div>
              <p class="centered-text desc-p"> 专注于室内园艺领域，以 “营造绿色办公环境，提升空间生态品质” 为使命。 </p>
            </div>
          </div>
          <div class="row">
            <div class="medium-2 large-2 columns">
              <div class="mod modMilestone"> <i class="fa fa-line-chart"></i>
                <p><span>在线咨询</span></p>
                <div class="four spacing"></div>
              </div>
            </div>
            <div class="medium-2 large-2 columns">
              <div class="mod modMilestone"> <i class="fa fa-anchor"></i>
                <p><span>选择方案</span></p>
                <div class="four spacing"></div>
              </div>
            </div>
            <div class="medium-2 large-2 columns">
              <div class="mod modMilestone"> <i class="fa fa-globe"></i>
                <p><span>签订合同</span></p>
                <div class="four spacing"></div>
              </div>
            </div>
            <div class="medium-2 large-2 columns">
              <div class="mod modMilestone"> <i class="fa fa-desktop"></i>
                <p><span>植物备货</span></p>
                <div class="four spacing"></div>
              </div>
            </div>
            <div class="medium-2 large-2 columns">
              <div class="mod modMilestone"> <i class="fa fa-thumbs-up"></i>
                <p><span>现场布置</span></p>
                <div class="four spacing"></div>
              </div>
            </div>
            <div class="medium-2 large-2 columns">
              <div class="mod modMilestone"> <i class="fa fa-picture-o"></i>
                <p><span>养护更换</span></p>
                <div class="four spacing"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full section-padding" id="index-news">
        <div class="container">
          <div class="row">
            <div class="large-12 columns">
              <div class="mod modSectionHeader">
                <div class="special-title centered-text">
                  <h2><a href="product.html">成功案例</a></h2>
                </div>
              </div>
              <p class="desc-p">百步花卉提供福州地区专业的花卉租摆服务，拥有丰富的花卉品种，为您打造舒适美观的办公和家居环境。</p>
            </div>
          </div>
          <div class="row">
            <div class="large-3 medium-3 columns iblog-item" v-for="(item) in productList" :key="item.productId">
              <div class="mod modBlogPost">
                <a :href="'productDetail.html?id='+item.productId">
                  <image-preview
                    :altText="item.productName ? '产品图片' : ''"
                    :imageUrl="item.productImg"
                    :height="300"
                  />
                </a>
                <div class="content">
                  <p class="date"><i class="fa fa-calendar"></i> &nbsp;{{item.createTime}}</p>
                  <h4 class="iblog-title"><a :href="'productDetail.html?id='+item.productId" :title="item.productName">{{ item.productName }}</a></h4>
                  <p class="desc" v-html="item.productRemark"></p>
                  <div class="tags"><a :href="'productDetail.html?id='+item.productId">查看详情 &nbsp;<i class="fa fa-angle-double-right"></i></a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
  </div>
</template>

<script>
import HeaderMenu from '@/components/header'
import FooterMenu from '@/components/footer'
import ImagePreview from '@/components/ImagePreview'
export default {
  components: {
    ImagePreview,
    HeaderMenu,
    FooterMenu
  },
  data () {
    return {
      productList: [],
      articleList: []
    }
  },
  created () {
  },
  mounted () {
    this.getIndexArticle()
    this.getIndexProduct()
  },
  methods: {
    getIndexArticle () {
      this.$api.getIndexArticle({ pageNum: 1, pageSize: 4, articleStatus: 1 }).then(res => {
        this.articleList = res.rows
      })
    },
    getIndexProduct () {
      this.$api.getIndexProduct({ pageNum: 1, pageSize: 8, productStatus: 1 }).then(res => {
        this.productList = res.rows
      })
    }
  }
}
</script>
<style lang="scss"></style>
